function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInstantticket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4cd263",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      fillOpacity: 1
    },
    d: "M 3.5625 1 C 2.1465 1 1 1.8646875 1 2.9296875 L 1 10.644531 C 3.819 10.644531 5.3652344 12.381906 5.3652344 14.503906 C 5.3652344 16.625906 3.819 18.359375 1 18.359375 L 1 26.070312 C 1 27.136312 2.1475 28 3.5625 28 L 39.4375 28 C 40.8525 28 42 27.135312 42 26.070312 L 42 18.361328 C 39.181 18.361328 37.634766 16.625906 37.634766 14.503906 C 37.634766 12.379906 39.181 10.644531 42 10.644531 L 42 2.9296875 C 42 1.8646875 40.8525 1 39.4375 1 L 3.5625 1 z M 20.796875 5.9589844 L 22.826172 5.9589844 L 22.826172 14.779297 L 26.689453 10.761719 L 28.130859 12.146484 L 21.822266 18.708984 L 15.513672 12.146484 L 16.955078 10.761719 L 20.796875 14.755859 L 20.796875 5.9589844 z M 14 21.138672 L 29.644531 21.138672 L 29.644531 23.138672 L 14 23.138672 L 14 21.138672 z ",
    id: "path7327"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstantticket);
export default __webpack_public_path__ + "static/media/ico-instantticket.281421a0.svg";
export { ForwardRef as ReactComponent };